import type { ProratedRentErrors, ProratedRentRawParams, ValidateResult } from './types';
import isEmpty from 'lodash/isEmpty';

export default function validate(params: ProratedRentRawParams): ValidateResult {
  const { monthlyRent, moveDate } = params;
  const errors: ProratedRentErrors = {};

  if (!validateMonthlyRent(monthlyRent)) {
    errors.monthlyRent = 'Please enter a number between 1 - 99,999';
  }

  if (!validateMoveDate(moveDate)) {
    errors.moveDate = 'Please select a valid date MM/DD/YYYY';
  }

  if (isEmpty(errors)) {
    return { isValid: true };
  }
  return { isValid: false, errors };
}

function validateMonthlyRent(rentString?: string): boolean {
  const floatRegExp = /^([0-9]*[.])?[0-9]+$/;
  if (rentString) {
    if (rentString.match(floatRegExp)) {
      const rentNumber = parseFloat(rentString);
      return rentNumber >= 1 && rentNumber <= 99999;
    }
  }
  return false;
}

function validateMoveDate(dateString?: string): boolean {
  const dateRegExp = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (dateString) {
    if (dateString.match(dateRegExp)) {
      return true;
    }
  }
  return false;
}
